import { customElement } from 'lit/decorators.js';
import { V6QuoteSupplierGlassView } from '../../../../quotes/v6/v6-quote-supplier-glass-view';

import { safeJsonHash } from '../../../../../webmodule-common/cache/persistent-api';
import { V6FranchiseeQuoteProviderData } from '../../data/franchisee-quote-provider-data';
@customElement('wm-franchiseev6quotesupplierglassview')
export class FranchiseeV6QuoteSupplierGlassView extends V6QuoteSupplierGlassView {
  protected getQuoteIGUs(): unknown {
    const data = this.quoteManager.quoteProviderData() as V6FranchiseeQuoteProviderData;
    return data.igu ?? [];
  }

  protected setQuoteIGUs(items: unknown) {
    const data = this.quoteManager.quoteProviderData() as V6FranchiseeQuoteProviderData;
    for (const item of items as any[]) {
      delete item.safeHash;
      const hash = safeJsonHash(item);
      item.safeHash = hash;
    }
    data.igu = items;
  }
}
